import React from 'react';
import moment from 'moment';
import { NameDateOption } from '../../Options.styles';
import { useIsWindowWiderThan } from '@common/hooks';
import { gridTheme } from '@utils/grid';
import BlockSelectField from '@common/components/FormElements/BlockSelectField';

const optionsForPerDate = (options) => {
  const isMobile = !useIsWindowWiderThan(gridTheme.breakpoints.md);
  return options.map((option, index) => ({
    label: isMobile ? (
      `${moment(option.startDate).format('MMM DD')}: ${option.name}`
    ) : (
      <NameDateOption>
        <strong>{option.name}</strong> {moment(option.startDate).format('MMM DD')}
      </NameDateOption>
    ),
    value: index,
  }));
};

export const PerDate = ({ field, options }) => {
  return (
    <BlockSelectField
      onChange={(value) => {
        field.onChange(value);
      }}
      value={field.value}
      options={optionsForPerDate(options)}
    />
  );
};
